// Defensive scan profiles used by the Scanner UI. Profile ids map to the
// backend nmap timing/port presets in scanner.PROFILES.
export const SCAN_PROFILES = [
  { id: 'stealth',    name: 'STEALTH',   desc: 'Lent, discret — top 100 ports',  color: 'info',        speed: 1 },
  { id: 'standard',   name: 'STANDARD',  desc: 'Équilibré — top 1000 ports',     color: 'accent',      speed: 3 },
  { id: 'aggressive', name: 'APPROFONDI', desc: 'Complet — top 3000 ports',       color: 'warning',     speed: 5 },
  { id: 'nuclear',    name: 'EXHAUSTIF', desc: 'Maximal — top 5000 ports',        color: 'destructive', speed: 6 },
];
